/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Receipt = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M21 1V23L18 21L15 23L12 21L9 23L6 21L3 23V1H21ZM19.5 2.5H4.5V20.196L6 19.1972L9 21.196L12 19.1972L15 21.196L18 19.1972L19.5 20.196V2.5ZM18 15V16.5H13V15H18ZM13 10V11.5H6V10H13ZM18 10V11.5H15V10H18ZM13 6V7.5H6V6H13ZM18 6V7.5H15V6H18Z"
                        fill={color}
                    />
                </svg>
        );
    };
